import { z } from 'zod';
export var ChecklistItem = z.object({
    key: z.string().prefault(''),
    completed: z.boolean().prefault(false)
});
export var ClinicalChecklist = z.object({
    checklist: z.array(ChecklistItem).prefault([])
}).prefault({
    checklist: []
});
